import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { API } from '../App';

export default function BlogListPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog?limit=50`)
      .then((r) => setPosts(r.data.posts || []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid="blog-list-page">
      <Header />
      <main className="flex-1 max-w-5xl mx-auto w-full px-6 md:px-12 py-12">
        <div className="mb-10">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-2 block">
            The Christ Kingdom Journal
          </span>
          <h1 className="text-3xl md:text-4xl font-heading font-medium tracking-tight">Stories, lessons & founder notes</h1>
        </div>

        {loading && <p className="text-muted-foreground">Loading…</p>}
        {!loading && posts.length === 0 && (
          <div className="py-16 text-center bg-muted/30 rounded-2xl border border-border/40">
            <p className="text-muted-foreground">No posts yet — check back soon.</p>
          </div>
        )}
        {!loading && posts.length > 0 && (
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {posts.map((p) => (
              <li key={p.post_id} className="group" data-testid={`blog-post-${p.slug}`}>
                <Link to={`/blog/${p.slug}`} className="block bg-background rounded-2xl overflow-hidden border border-border/40 hover:shadow-md transition-shadow">
                  {p.cover_image && (
                    <div className="aspect-[16/9] overflow-hidden">
                      <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    </div>
                  )}
                  <div className="p-5">
                    <h2 className="font-medium text-lg leading-snug mb-2">{p.title}</h2>
                    {p.excerpt && <p className="text-sm text-muted-foreground line-clamp-3 mb-4">{p.excerpt}</p>}
                    <div className="flex items-center gap-4 text-xs text-muted-foreground">
                      {p.author_name && (
                        <span className="inline-flex items-center gap-1"><User className="h-3 w-3" />{p.author_name}</span>
                      )}
                      {p.published_at && (
                        <span className="inline-flex items-center gap-1"><Calendar className="h-3 w-3" />{new Date(p.published_at).toLocaleDateString()}</span>
                      )}
                      <span className="inline-flex items-center gap-1 text-primary ml-auto">Read <ArrowRight className="h-3 w-3" /></span>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </main>
      <Footer />
    </div>
  );
}
